import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import {
  FileGet,
  SortGet,
} from "../../../../../../../_ovlclient/src/global/globalapi"
import { D, T } from "../../../../../../../_ovlclient/src/global/globals"

import { ScreenNavigateTo } from "../../../../../../../_ovlclient/src/library/screenapi"
import type { DownloadPopup } from "../../../parts/downloadpopup/downloadpopup"
import { FileType } from "../../../parts/filelist/filelist"

export class CompOrderOverview extends SYSBaseElement {
  // handleFile(e: Event, fileName: string, fileType: FileType, docNum: string) {
  //   e.preventDefault()
  //   FileGet({
  //     ext: "",
  //     id1: fileName,
  //     cat: fileType,
  //     id2: docNum,
  //   })
  // }
  handleDetail(e: Event, key: string) {
    //@ts-ignore
    if (
      (!this.state.app.screens.DATOrder.orderOverview.activeFilePopup &&
        //@ts-ignore
        e.target.localName === "td") ||
      //@ts-ignore
      e.target.localName === "button"
    ) {
      this.actions.app.features.DATFeedback.actions.SelectOrder(key)
      ScreenNavigateTo("DATOrderdetail")
      e.stopPropagation()
    }
  }

  handlePaketSearch(e: Event, key: string) {
    e.stopPropagation()
    this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder = key
    ScreenNavigateTo("DATSearchPaket")
  }

  async getUI() {
    const handleRemoveAllPDFPopup = (e) => {
      this.actions.app.global.actions.TogglePDFPopup({
        key: "",
        obj: this.state.app.screens.DATOrder.orderOverview,
      })
    }
    let channelGroupHeaderDisplayed: Set<string> = new Set()

    let detailCount = Object.keys(
      this.state.app.screens.DATOrder.orderDetail.orders
    ).length
    if (detailCount === 0) {
      return null
    }
    let orders = this.state.app.screens.DATOrder.orderDetail.orders
    return html`
      <div
        @click=${handleRemoveAllPDFPopup}
        class="app-document-overview ovl-smart-padding-lr-symmetrical ovl-smart-screen-margins"
      >
        <div class="fd-layout-panel">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="sap-icon--sales-order sap-icon--xl">
                ${T("DATDocumentDataOrders")}
              </h3>
              <h4>
                ${T("DATDocumentDataOrderListTitle", [detailCount.toString()])}
              </h4>
            </div>
          </div>

          <div class="fd-layout-panel__body">
            <table class="fd-table">
              <thead class="fd-table__header">
                <tr class="fd-table__row ">
                  <th class="fd-table__cell" width="2%" scope="col">
                    ${T("GENPDF")}
                  </th>
                  <th class="fd-table__cell" width="4%" scope="col">
                    ${T("GENNumber")}
                  </th>
                  <th class="fd-table__cell" width="38%" scope="col">
                    ${T("GENCommission")}
                  </th>
                  <th class="fd-table__cell" width="26%" scope="col">
                    ${T("GENSalesOrderColSearchPaket")}
                  </th>
                  <th class="fd-table__cell" width="28%" scope="col">
                    ${T("DATDocumentDataDeliveryDate")}
                  </th>
                </tr>
              </thead>
              <tbody class="fd-table__body">
                ${Object.keys(orders)
                  .sort((a, b) => {
                    let res = SortGet(orders[b].orderType, orders[a].orderType)
                    if (res === 0) {
                      res = parseInt(b) - parseInt(a)
                    }
                    return res
                  })
                  .map((k) => {
                    let order = orders[k]
                    let downloadPopup
                    if (order.orderType === "own") {
                      downloadPopup = html`<comp-downloadpopup
                        .props=${() => {
                          return <DownloadPopup>{
                            activePopupKey:
                              this.state.app.screens.DATOrder.orderOverview
                                .activeFilePopup,
                            docNum: k,
                            documentDetailsState:
                              this.state.app.screens.DATOrder.orderDetail
                                .orders,
                            documentScreensState:
                              this.state.app.screens.DATOrder.orderOverview,

                            popupId: "ovlpdfpop1",
                            type: "Order",
                            onOpen: async () => {
                              await this.actions.app.screens.DATOrderdetail.actions.FetchOrderDetail(
                                k
                              )
                            },
                          }
                        }}
                      >
                      </comp-downloadpopup>`
                    }

                    let channelGroupHeader
                    if (
                      order.orderType === "channel" &&
                      !channelGroupHeaderDisplayed.has(order.cardName)
                    ) {
                      channelGroupHeaderDisplayed.add(order.cardName)
                      channelGroupHeader = html` <tr>
                        <td
                          class="fd-table__cell ovl-channelgroupheader"
                          colspan="5"
                        >
                          ${T("GENChannelNameGroupHeader", [order.cardName])}
                        </td>
                      </tr>`
                    }

                    return html`
                      ${channelGroupHeader}
                      <tr
                        class="fd-table__row fd-table__row--hoverable"
                        @click=${(e) => this.handleDetail(e, k)}
                      >
                        <td class="fd-table__cell">${downloadPopup}</td>
                        <td class="fd-table__cell ">
                          <button
                            title="${T("GENDetails")}"
                            @click=${(e) => this.handleDetail(e, k)}
                            class="fd-button fd-button--compact"
                          >
                            ${k}
                          </button>
                        </td>
                        <td class="fd-table__cell ">${order.refNum}</td>
                        <td class="fd-table__cell ">
                          <button
                            title="${T("GENSalesOrderColSearchPaket")}"
                            @click=${(e) => this.handlePaketSearch(e, k)}
                            class="fd-button fd-button--compact"
                          >
                            ...
                          </button>
                        </td>

                        <td class="fd-table__cell ">
                          ${D(order.deliveryDate)}
                        </td>
                      </tr>
                    `
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `
  }
}
